import React from "react"
import type { Narrative } from "~/api/portfolio_summaries"

interface NarrativeCardProps {
  narrative: Narrative
  periodLabel: string
}

const NarrativeCard: React.FC<NarrativeCardProps> = ({
  narrative,
  periodLabel,
}) => (
  <div className="b-portfolio-summary-ai-card">
    <div className="b-portfolio-summary-ai-header">
      <span className="b-portfolio-summary-ai-badge">
        <span className="b-portfolio-summary-ai-dot" />
        SUMMARY
      </span>
      <span className="b-portfolio-summary-ai-title">
        {periodLabel} quarter-over-quarter review
      </span>
      <span className="b-portfolio-summary-ai-meta">
        Templated from cached figures — not LLM-generated
      </span>
    </div>
    <div className="b-portfolio-summary-ai-body">
      {narrative.paragraphs.map((p, i) => (
        <p key={i}>{p}</p>
      ))}

      <div className="b-portfolio-summary-ai-cols">
        <div>
          <p className="b-portfolio-summary-ai-section">
            Portfolio activity — quarter
          </p>
          <ul className="b-portfolio-summary-ai-list">
            {narrative.activity.length === 0 && (
              <li>No notable capital calls or MV moves this quarter.</li>
            )}
            {narrative.activity.map((item, i) => (
              <li key={i}>
                <span
                  className={`b-portfolio-summary-ai-tag b-portfolio-summary-ai-tag--${item.tag.toLowerCase()}`}
                >
                  {item.tag}
                </span>
                <span>{item.text}</span>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="b-portfolio-summary-ai-section">
            Key attribution — QoQ
          </p>
          <ul className="b-portfolio-summary-ai-list">
            {narrative.attribution.map((item, i) => (
              <li key={i}>
                <span className="b-portfolio-summary-ai-tag b-portfolio-summary-ai-tag--neutral">
                  {item.label}
                </span>
                <span>{item.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
    <div className="b-portfolio-summary-ai-disclaimer">
      Prototype narrative generated by templating real cached figures — this is
      not an LLM summary. Any future AI-generated narrative would need CCO /
      compliance review before internal or client use.
    </div>
  </div>
)

export default NarrativeCard
